import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.updateUser.label",
    defaultMessage: "Edit",
    description: "label for update user button",
  },
});
